<template>
    <div class="information">
        <div class="title">录入个人信息</div>
        <div class="content">
            <div class="input">
                <div>
                    <label><i>*</i>Name 名字：</label>
                    <Input placeholder="Name 名字" v-model='name' style="width: 300px"></Input>
                </div>
                <b class='error' v-show='errorlist.name'>{{errorlist.name}}</b>
            </div>
            <div class="input">
                <div>
                    <label><i>*</i>WA/WC 賬戶號碼：</label>
                    <Input placeholder="WA/WC 賬戶號碼" v-model='wawc' style="width: 300px"></Input>
                </div>
                <b class='error' v-show='errorlist.wawc'>{{errorlist.wawc}}</b>
            </div>
            <div class="input">
                <div>
                    <label><i>*</i>Birth 出生日期：</label>
                    <Input placeholder="Birth 出生日期" v-model='birthday' style="width: 300px"></Input>
                </div>
                <b class='error' v-show='errorlist.birthday'>{{errorlist.birthday}}</b>
            </div>
            <div class="input">
                <div>
                    <label><i>*</i>ID or Passport Last 4 Digit 証件尾4位子母:</label>
                    <Input placeholder="ID or Passport Last 4 Digit 証件尾4位子母" v-model='digit' style="width: 300px"></Input>
                </div>
                <b class='error' v-show='errorlist.digit'>{{errorlist.digit}}</b>
            </div>
            <div class="input">
                <div>
                    <label><i>*</i>Contact 聯絡電話：</label>
                    <Input placeholder="Contact 聯絡電話" v-model='contact' style="width: 300px"></Input>
                </div>
                <b class='error' v-show='errorlist.contact'>{{errorlist.contact}}</b>
            </div>
            <div class="input">
                <div>
                    <label><i>*</i>Email 電郵：</label>
                    <Input placeholder="Email 電郵" v-model='email' style="width: 300px"></Input>
                </div>
                <b class='error' v-show='errorlist.email'>{{errorlist.email}}</b>
            </div>
            <div class="input">
                <div>
                    <label><i>*</i>Receiver Name：</label>
                    <Input placeholder="Receiver Name" v-model='receivername' style="width: 300px"></Input>
                </div>
                <b class='error' v-show='errorlist.receivername'>{{errorlist.receivername}}</b>
            </div>
            <div class="input">
                <div>
                    <label><i>*</i>HK Contact#：</label>
                    <Input placeholder="HK Contact" v-model='hkcontact' style="width: 300px"></Input>
                </div>
                <b class='error' v-show='errorlist.hkcontact'>{{errorlist.hkcontact}}</b>
            </div>
            <div class="input">
                <div>
                    <label><i>*</i>Email：</label>
                    <Input placeholder="Email" v-model='emaill' style="width: 300px"></Input>
                </div>
                <b class='error' v-show='errorlist.emaill'>{{errorlist.emaill}}</b>
            </div>
            <div class="input">
                <div>
                    <label><i>*</i>Shipping Line1：</label>
                    <Input placeholder="Shipping Line1" v-model='shippingline1' style="width: 300px"></Input>
                </div>
                <b class='error' v-show='errorlist.shippingline1'>{{errorlist.shippingline1}}</b>
            </div>
            <div class="input">
                <div>
                    <label><i>*</i>Line 2：</label>
                    <Input placeholder="Line 2" v-model='shippingline2' style="width: 300px"></Input>
                </div>
                <b class='error' v-show='errorlist.shippingline2'>{{errorlist.shippingline2}}</b>
            </div>
            <div class="input">
                <div>
                    <label><i>*</i>District：</label>
                    <Input placeholder="District" v-model='district' style="width: 300px"></Input>
                </div>
                <b class='error' v-show='errorlist.district'>{{errorlist.district}}</b>
            </div>
            <div class="input">
                <div>
                    <label><i>*</i>Region：</label>
                    <Input placeholder="Region" v-model='region' style="width: 300px"></Input>
                </div>
                <b class='error' v-show='errorlist.region'>{{errorlist.region}}</b>
            </div>
        </div>
    </div>
</template>

<script>
import {
	mapState,
	mapMutations,
	mapActions
} from 'vuex'
export default {
	data() {
		return {
            name: '',
            wawc: '',
            birthday: '',
            digit: '',
            contact: '',
            email: '',
            receivername: '',
            hkcontact: '',
            emaill: '',
            shippingline1: '',
            shippingline2: '',
            district: '',
            region: '',
            errorlist: {
                name: null,
                wawc: null,
                birthday: null,
                digit: null,
                contact: null,
                email: null,
                receivername: null,
                hkcontact: null,
                emaill: null,
                shippingline1: null,
                shippingline2: null,
                district: null,
                region: null,
            }
		}
	},
	created() {
		this.$nextTick(function() {
			this.initData()
		})
	},
	mounted() {

	},
	watch:{

	},
	mixins:[],
	components: {
	},
	computed: {
		...mapState({
		}),
	},
	methods: {
		...mapActions([
		]),
		async initData(){
            this.errorlist.name = 'Only Support English, Simp Chinese & Trad Chinese';
            this.errorlist.wawc = 'Only Support Numeric';
            this.errorlist.birthday = 'Fixed Format XXXX Year年 XX Month月 XX Day日';
            this.errorlist.digit = 'Only Support Numeric';
            this.errorlist.contact = 'Only Support Numeric';
            this.errorlist.email = 'Required xxx@xxx.com';
            this.errorlist.receivername = 'Only Support English, Simp Chinese & Trad Chinese';
            this.errorlist.hkcontact = 'Max & Min 8-digit number';
            this.errorlist.emaill = 'XXX@XXX.com';
            this.errorlist.shippingline1 = 'Only Support English, Simp Chinese & Trad Chinese';
            this.errorlist.shippingline2 = 'Only Support English, Simp Chinese & Trad Chinese';
            this.errorlist.district = 'Multiple Choice for HK/Kowloon/New Territories/ Outlying Islands/Macau/香港/九龍/新界/離島/澳門';
            this.errorlist.region = 'Multiple Choice for Hong Kong/Macau/香港/澳門';
		},
	},
}
</script>

<style lang='scss' scoped>
.information{
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 100px;
    .title{
        color: #bc86c8;
        font-size: 18px;
        border-bottom: 2px solid #bc86c8;
    }
    .content{
        margin: 20px;
        .input{
            margin-bottom: 10px;
            label {
                width: 180px;
                display: inline-block;
                text-align: right;
                margin-right: 40px;
                i {
                    color: red;
                }
            }
        }
    }
    .error {
        color: red;
        margin: 10px 0 10px 220px;
        font-weight: 400;
    }
    .error_border input {
        border-radius: 4px;
        border: 1px solid red;
    }
}
</style>